import React from 'react';

import { cn } from 'components/app-components/ui/utils';
import { colorForId } from 'lib/avatarPalette';
import { getInitials } from 'utils/string';

export type ProfileCircleSize = '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const SIZE_CLASSES: Record<ProfileCircleSize, string> = {
  '2xs': 'h-6 w-6 text-[8px]',
  xs: 'h-7 w-7 text-[10px]',
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-12 w-12 text-base',
  xl: 'h-16 w-16 text-lg',
};

interface ProfileCircleProps {
  /** A full name, or initials that are already worked out. Either way it is normalised to initials. */
  text?: string | null;
  /** Anything stable about the person (or team, or company): the circle colour is hashed from it. */
  id?: string | null;
  size?: ProfileCircleSize;
  className?: string;
  textClassName?: string;
}

function ProfileCircle({ text, id, size = 'md', className = '', textClassName = '' }: ProfileCircleProps) {
  const colors = colorForId(id);

  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full',
        SIZE_CLASSES[size],
        colors.bg,
        className,
      )}
    >
      <span
        className={cn('inline-flex items-center justify-center font-medium leading-none', colors.text, textClassName)}
      >
        {getInitials(text)}
      </span>
    </span>
  );
}

const MemoizedProfileCircle = React.memo(ProfileCircle);

export default MemoizedProfileCircle;
